import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { POINT_PAGE_NAME } from '../../constants/service/app/pointConstants';
import PointGenerateContainer from '../../containers/point/PointGenerateContainer';

const PointGenerate = () => {
  return (
    <PageTemplate pageName={POINT_PAGE_NAME.POINT_GENERATE}>
      <PointGenerateContainer />
    </PageTemplate>
  );
};

export default PointGenerate;
